<template>
  <div>
    <div>
      <!-- <span slot="label">{{courseTypeText}}</span> -->
      <div>
        <el-row class="cs-filter-row">
          <el-col>
            <el-row>
              <el-col :span="4">
                <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search"
                  v-model.trim="searchCondition.phone" @change="onSearchConditionChanged" @keyup.enter.native="onSearchClick">
                </el-input>
              </el-col>
              <el-col :span="4" class="cs-datepick-col">
                <el-date-picker class="cs-accountList-searchDate margin-left-20px" v-model="searchCondition.searchDate"
                  type="daterange" align="center" unlink-panels range-separator="-" start-placeholder="开始" end-placeholder="结束"
                  :picker-options="pickerOptions" size="medium" @change="onSearchConditionChanged"></el-date-picker>
              </el-col>
              <el-col :span="4" class="cs-saleQuery-buttons">
                <el-button size="medium" type="primary" @click="onSearchClick">搜索</el-button>
              </el-col>
            </el-row>
            <el-row class="margin-top-10">
              <el-col :span="4">
                <el-select placeholder="大学" v-model="searchCondition.universityId" @change="onSearchConditionChanged"
                  size="medium">
                  <el-option v-for="item in universityList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select placeholder="渠道" v-model="searchCondition.channelId" @change="onSearchConditionChanged" size="medium"
                  class="margin-left-20px">
                  <el-option v-for="item in channelList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select placeholder="收款类型" v-model="searchCondition.payeeType" @change="onSearchConditionChanged" size="medium"
                  class="margin-left-20px">
                  <el-option v-for="item in payeeTypeList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" v-if="searchCondition.payeeType == 1">
                <el-select placeholder="底价模式" v-model="searchCondition.bottomPriceType" @change="onSearchConditionChanged"
                  size="medium" class="margin-left-20px">
                  <el-option v-for="item in bottomPriceTypeList" :key="item.Key" :label="item.Value" :value="item.Key">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select placeholder="类型" v-model="searchCondition.status" @change="onSearchConditionChanged" size="medium"
                  class="margin-left-20px">
                  <el-option v-for="item in statusList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
                </el-select>
              </el-col>
             
            </el-row>
          </el-col>
        </el-row>
        <el-row class="margin-top-10">
          <el-col :span="4">
            <el-select v-model="searchCondition.studyAbroadBusinessType" @change="onSearchConditionChanged" size="medium">
              <el-option :key="-1" label="所有业务类型" :value="null" />
              <el-option v-for="item in GLOBAL.enumBusinessType.getOptions()" :key="item.key" :label="item.desc" :value="item.value" />
            </el-select>
          </el-col>
          <el-col :span="8">
            <tree-select class="margin-left-20px" key-field="ID" label-field="Name" value-field="ID" children-field="Children"
             v-model="searchCondition.serviceOrItemId" :data-source="studyAbroadServices" :default-collapse="true " size="medium"
             :clearable="false">
            </tree-select>
          </el-col>
        </el-row>
        <hr />
        <div v-loading="isLoadingSaleSummary" class="cs-saleQuery-summary">
          <el-row class="cs-saleQuery-summary-container">
            <el-col :span="11" class="cs-saleQuery-summary-left">
              <el-row>
                <el-col :span="spanTitle">
                  <span class="cs-saleQuery-summary-title">实时报名人数</span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalStudentCount
                  }}</span>
                </el-col>
              </el-row>
              <el-row class="cs-saleQuery-summary-row">
                <el-col :span="spanTitle">
                  <span class="cs-saleQuery-summary-title">实时价值收入<el-tooltip class="item" effect="dark" content="打折前的收入"
                      placement="top">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </el-tooltip></span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalIncomeCAD | toCurrency(GLOBAL.currencyType.CAD)
                  }}</span>
                </el-col>
                <el-col :span="1">
                  <span class="cs-mark">
                    |
                  </span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalIncomeCNY | toCurrency(GLOBAL.currencyType.CNY)
                  }}</span>
                </el-col>
              </el-row>
              <el-row class="cs-saleQuery-summary-row">
                <el-col :span="spanTitle">
                  <span class="cs-saleQuery-summary-title">实时销售收入<el-tooltip class="item" effect="dark" content="打折后的收入"
                      placement="top">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </el-tooltip></span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalSaleIncomeCAD | toCurrency(GLOBAL.currencyType.CAD)
                  }}</span>
                </el-col>
                <el-col :span="1">
                  <span class="cs-mark">
                    |
                  </span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalSaleIncomeCNY | toCurrency(GLOBAL.currencyType.CNY)
                  }}</span>
                </el-col>
              </el-row>
              <el-row class="cs-saleQuery-summary-row">
                <el-col :span="spanTitle">
                  <span class="cs-saleQuery-summary-title">实时应到款收入<el-tooltip class="item" effect="dark" content="实时销售收入减去佣金 "
                      placement="top">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </el-tooltip></span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalStorageIncomeCAD | toCurrency(GLOBAL.currencyType.CAD)
                  }}</span>
                </el-col>
                <el-col :span="1">
                  <span class="cs-mark">
                    |
                  </span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalStorageIncomeCNY | toCurrency(GLOBAL.currencyType.CNY)
                  }}</span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="1">
              &nbsp;
            </el-col>
            <el-col :span="11">
              <el-row class="cs-saleQuery-summary-row">
                <el-col :span="spanTitle">
                  <span class="cs-saleQuery-summary-title">实时真实收入<el-tooltip class="item" effect="dark"
                      content="实时应到收入减去欠款、退款" placement="top">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </el-tooltip></span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalRealIncomeCAD | toCurrency(GLOBAL.currencyType.CAD)
                  }}</span>
                </el-col>
                <el-col :span="1">
                  <span class="cs-mark">
                    |
                  </span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalRealIncomeCNY | toCurrency(GLOBAL.currencyType.CNY)
                  }}</span>
                </el-col>
              </el-row>
              <el-row class="cs-saleQuery-summary-row">
                <el-col :span="spanTitle">
                  <span class="cs-saleQuery-summary-title">实时支出金额<el-tooltip class="item" effect="dark" content="提供的项目成本价格"
                      placement="top">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </el-tooltip></span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalExpenseCAD | toCurrency(GLOBAL.currencyType.CAD)
                  }}</span>
                </el-col>
                <el-col :span="1">
                  <span class="cs-mark">
                    |
                  </span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalExpenseCNY | toCurrency(GLOBAL.currencyType.CNY)
                  }}</span>
                </el-col>
              </el-row>
              <el-row class="cs-saleQuery-summary-row">
                <el-col :span="spanTitle">
                  <span class="cs-saleQuery-summary-title">实时真留权责收入<el-tooltip class="item" effect="dark" content="已完成服务的收入"
                      placement="top">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </el-tooltip></span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalServiceCompleteCAD | toCurrency(GLOBAL.currencyType.CAD)
                  }}</span>
                </el-col>
                <el-col :span="1">
                  <span class="cs-mark">
                    |
                  </span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalServiceCompleteCNY | toCurrency(GLOBAL.currencyType.CNY)
                  }}</span>
                </el-col>
              </el-row>
              <el-row class="cs-saleQuery-summary-row">
                <el-col :span="spanTitle">
                  <span class="cs-saleQuery-summary-title">实时未消耗服务价值<el-tooltip class="item" effect="dark" content="未完成服务的价值"
                      placement="top">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </el-tooltip></span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalServiceUnusedCAD | toCurrency(GLOBAL.currencyType.CAD)
                  }}</span>
                </el-col>
                <el-col :span="1">
                  <span class="cs-mark">
                    |
                  </span>
                </el-col>
                <el-col :span="2">
                  <span class="cs-amount">{{
                    summaryData.TotalServiceUnusedCNY | toCurrency(GLOBAL.currencyType.CNY)
                  }}</span>
                </el-col>
              </el-row>
              <el-row class="cs-saleQuery-summary-row">
                <el-col :span="spanTitle">
                  <span class="cs-saleQuery-summary-title">实时退款<el-tooltip class="item" effect="dark" content="退款服务的价值"
                      placement="top">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </el-tooltip></span>
                </el-col>
                <el-col :span="spanNumber">
                  <span class="cs-amount">{{
                    summaryData.TotalRefundCAD | toCurrency(GLOBAL.currencyType.CAD)
                  }}</span>
                </el-col>
                <el-col :span="1">
                  <span class="cs-mark">
                    |
                  </span>
                </el-col>
                <el-col :span="2">
                  <span class="cs-amount">{{
                    summaryData.TotalRefundCNY | toCurrency(GLOBAL.currencyType.CNY)
                  }}</span>
                </el-col>
              </el-row>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="3" class="cs-saleQuery-summary-explain">
              <el-button type="text" class="btn-details" @click="toggleProfitDetailVisible">
                <template>
                  <i class="el-icon-caret-bottom" v-if="showProfitDetail">&nbsp;</i>
                  <i class="el-icon-caret-right" v-else>&nbsp;</i>收益详情
                </template>
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div v-loading="isLoadingSaleSummary" v-show="showProfitDetail" class="cs-saleQuery-summary-detail">
          <el-table class="profit-table" :span-method="profitTableSpan" :data="summaryData.departmentProfits">
            <el-table-column label="">
              <template slot-scope="scope">
                {{scope.row.ProfitItemName}}
              </template>
            </el-table-column>
            <el-table-column label="币种" prop="CurrencyName" />
            <el-table-column label="笔头帮" prop="BiTouBang">
              <template #default="{row, column}">
                <span>{{Object.toCurrency(row[column.property], row.Currency)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="大学补习" prop="University">
              <template #default="{row, column}">
                <span>{{Object.toCurrency(row[column.property], row.Currency)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="职业培训" prop="VocationalTraining">
              <template #default="{row, column}">
                <span>{{Object.toCurrency(row[column.property], row.Currency)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="学术督导" prop="AcademicSupervision">
              <template #default="{row, column}">
                <span>{{Object.toCurrency(row[column.property], row.Currency)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="市场" prop="Marketing">
              <template #default="{row, column}">
                <span>{{Object.toCurrency(row[column.property], row.Currency)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-row class="grid-content">
          <el-col>
            <pagination v-loading="loading" :data="listData" :option="paginationOption" @search="search" @loadData="search"
              @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange" @edit="onTableEdit"></pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.no-padding {
  padding: unset !important;
}

.profit-table {
  width: 100%;
}

body .cs-filter-row {
  padding-top: 10px;
}
.cs-totalAmount {
  font-size: 18px;
  font-weight: bold;
}

.cs-recordCount {
  color: gray;
  margin-left: 10px;
}

.cs-datepick-col {
  width: 270px;

  .cs-accountList-searchDate {
    width: 250px !important;

    .el-range-separator {
      z-index: 99;
    }
  }
}
.cs-saleQuery-buttons {
  text-align: center;
}
.cs-saleQuery-summary {
  font-size: 16px;
  
  i {
    color: #409eff;
    vertical-align: middle;
  }

  .cs-saleQuery-summary-detail {
    font-size: 11px;
    line-height: 16px;
    .cs-amount {
      font-size: 13px;
    }
  }

  .cs-saleQuery-summary-container{
    display: flex;
    align-items: stretch;
  }
  .cs-saleQuery-summary-left {
    border-right: 1px solid #ced3d9;
  }

  .cs-saleQuery-summary-row {
    i{
      margin-left: 5px;
    }
    .el-col {
      &:nth-of-type(2) {
      }
    }

    .cs-mark {
      color: #ced3d9;
    }
  }

  .cs-saleQuery-summary-explain {
    // height: calc(24px * 4);
    margin-top: 10px;
    display: block;

    .btn-details {
      line-height: 24px;
      height: 24px;
      padding: 0;
      margin-top: auto;
      margin-left: auto;
    }
  }
}
</style>

<script>
import pagination from "../common/pagination";
import treeSelect from "../common/tree-select";

import { addMonth, formatDate, toDecimal } from "../../config/mUtils.js";
import { getUniversities } from "../../service/common.service";
import {
  getChannelItems,
  getSalesQuerySummary,
  getSalesQueryList,
  getAllStudyAbroadServicesForTreeSelect
} from "../../service/studyAbroad.service";

export default {
  props: {
    isActive: Boolean,
  },
  data() {
    return {
      studyAbroadServices:[],
      spanTitle: 10,
      spanNumber: 6,
      searchCondition: {
        phone: "",
        searchDate: "",
        universityId: 0,
        channelId: 0,
        payeeType: -1,
        bottomPriceType: 0,
        status: 0,
        studyAbroadBusinessType: null,
        serviceOrItemId: {
          level: 0,
          value: ''
        }
      },
      universityList: [{ Key: 0, Value: "所有大学" }],
      channelList: [
        {
          Key: 0,
          Value: "所有销售渠道",
        },
      ],
      payeeTypeList: [
        {
          Key: -1,
          Value: "所有收款类型",
        },
        {
          Key: 0,
          Value: "速成收款",
        },
        {
          Key: 1,
          Value: "渠道收款",
        },
      ],
      bottomPriceTypeList: [
        {
          Key: 0,
          Value: "显示所有(底价模式)",
        },
        {
          Key: 1,
          Value: "底价模式",
        },
        {
          Key: 2,
          Value: "非底价模式",
        },
      ],
      statusList: [
        {
          Key: 0,
          Value: "显示所有(类型)",
        },
        {
          Key: 1,
          Value: "欠款",
        },
        {
          Key: 2,
          Value: "退款",
        },
        {
          Key: 3,
          Value: "服务费已到账",
        },
        {
          Key: 4,
          Value: "服务费未到账",
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      loading: false,
      isLoadingSaleSummary: false,
      showProfitDetail: false,
      listData: {},
      pageSize: 20,
      summaryData: {
        TotalStudentCount: 0,
        TotalIncomeCNY: 0,
        TotalIncomeCAD: 0,
        TotalSaleIncomeCNY: 0,
        TotalSaleIncomeCAD: 0,
        TotalStorageIncomeCNY: 0,
        TotalStorageIncomeCAD: 0,
        TotalRealIncomeCNY: 0,
        TotalRealIncomeCAD: 0,
        TotalExpenseCNY: 0,
        TotalExpenseCAD: 0,
        TotalServiceCompleteCNY: 0,
        TotalServiceCompleteCAD: 0,
        TotalServiceUnusedCNY: 0,
        TotalServiceUnusedCAD: 0,
        departmentProfits: []
      },
    };
  },
  components: {
    navigator,
    pagination,
    treeSelect
  },
  created() {
    this.loadDropdownList();

    this.paginationOption = {
      displayPagination: true,
      hasEditButton: true,
      editButtonText: "查看详情",
      hasAddButton: false,
      hasSearch: false,
      hasDateSearch: false,
      buttonWidth: 100,
    };
    this.searchCondition.searchDate = [];
    let today = new Date();
    this.searchCondition.searchDate.push(today);
    this.searchCondition.searchDate.push(today);

    this.init();
    this.search();
  },
  methods: {
    init() {
      getAllStudyAbroadServicesForTreeSelect().then((rs) => {
        if(rs.success)
          this.studyAbroadServices = [{ID: '', Name: '不限服务', Children: []}].concat(rs.data);
      });
    },
    profitTableSpan(arg) {
      if (arg.columnIndex === 0) {
          if (arg.rowIndex % 2 === 0) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
    },
    toggleProfitDetailVisible(){
      this.showProfitDetail = !this.showProfitDetail;
    },
    loadDropdownList() {
      getUniversities().then((result) => {
        if (!!result && result.success) {
          this.universityList = this.universityList.concat(result.data);
        }
      });

      getChannelItems().then((result) => {
        if (!!result && result.success) {
          this.channelList = this.channelList.concat(result.data);
        } else {
          this.channelList = [
            {
              Key: "",
              Value: "所有销售渠道",
            },
          ];
        }
      });
    },
    onSearchConditionChanged() {},
    onSearchClick() {
      this.search();
    },
    search(pageData) {
      if (!this.isActive) {
        return;
      }
      let searchData = this.getSearchPageData(pageData);
      this.loadSalesQueryData(searchData);
      this.loadSalesSummaryData(searchData);
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageData) {
      if (typeof pageData == "undefined" || pageData == 1) {
        pageData = {
          pageNumber: 1,
        };
      }

      let startDate = "";
      let endDate = "";

      let serviceId = null;
      let serviceItemId = null;
      if(this.searchCondition.serviceOrItemId !== null) {
        if(this.searchCondition.serviceOrItemId.level === 0) {
          serviceId = this.searchCondition.serviceOrItemId.value;
        }
        else {
          serviceItemId = this.searchCondition.serviceOrItemId.value;
        }
      }
      if (
        !!this.searchCondition.searchDate &&
        this.searchCondition.searchDate.length == 2
      ) {
        startDate = formatDate(this.searchCondition.searchDate[0]);
        endDate = formatDate(this.searchCondition.searchDate[1]);
      }

      let additionalFilter = {
        universityId: this.searchCondition.universityId,
        channelId: this.searchCondition.channelId,
        payeeType: this.searchCondition.payeeType,
        bottomPriceType: this.searchCondition.bottomPriceType,
        status: this.searchCondition.status,
        studyAbroadBusinessType: this.searchCondition.studyAbroadBusinessType,
        serviceId: serviceId,
        serviceItemId: serviceItemId
      };
      let searchData = {
        pageSize: this.pageSize,
        keyWord: this.searchCondition.phone,
        startDate: startDate,
        endDate: endDate,
        additionalFilter: additionalFilter,
      };
      searchData = $.extend({}, pageData, searchData);
      return searchData;
    },
    loadSalesQueryData(pageData) {
      this.loading = true;
      getSalesQueryList(pageData)
        .then((result) => {
          if (result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    loadSalesSummaryData(pageData) {
      this.isLoadingSaleSummary = true;
      getSalesQuerySummary(pageData)
        .then((result) => {
          if (result && result.success) {
            this.summaryData = result.data;
          }
          this.isLoadingSaleSummary = false;
        })
        .catch((error) => {
          this.isLoadingSaleSummary = false;
        });
    },
    onTableEdit(index, row) {
      let navList = JSON.stringify([this.$route.path]);

      this.$router.push({
        path: "/studyAbroad/accountDetail",
        query: {
          workflowId: row.WorkflowId,
          navList: this.$cryptoJS.enc.Base64.encode(navList),
        },
      });
    },
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
        this.search();
      }
    },
    queryData: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/salesQuery/studyAbroadSalesQueryList.vue